<div *ngIf="dataLoaded" class="card card-custom gutter-b">
    <div class="card-header border-0">
        <div class="card-title">
            <h3 class="card-label m-0" translate="PROJECTS.EDIT_TASK"></h3>
        </div>
        <div class="card-toolbar">
            <button *ngIf="stageId !== '0' && isTaskFromTable === false && isFromTasksModule === false" type="button" class="btn-back"
                    routerLink="/projects/{{projectId}}/stage/{{stageId}}/view/{{taskId}}/view">
                <span class="fa fa-arrow-left"></span>
            </button>

            <button *ngIf="stageId !== '0' && isTaskFromTable === true && isFromTasksModule === false" type="button" class="btn-back"
                    routerLink="/projects/{{projectId}}/{{taskId}}/view">
                <span class="fa fa-arrow-left"></span>
            </button>

            <button *ngIf="stageId === '0' && isFromTasksModule === false" type="button" class="btn-back"
                    routerLink="/projects/{{projectId}}/{{taskId}}/view">
                <span class="fa fa-arrow-left"></span>
            </button>

            <button *ngIf="stageId === '0' && isFromTasksModule === true" type="button" class="btn-back"
                    routerLink="/tasks">
                <span class="fa fa-arrow-left"></span>
            </button>

            <button *ngIf="stageId !== '0' && isFromTasksModule === true" type="button" class="btn-back"
                    routerLink="/tasks">
                <span class="fa fa-arrow-left"></span>
            </button>
        </div>
    </div>

    <div class="card-body">
        <app-form-message *ngIf="formSent" [success]="formResponse" [customErrorMessage]="errorMsg"
                          [customSuccessMessage]="successMsg"></app-form-message>

        <form [formGroup]="editTaskForm" (ngSubmit)="submitTaskForm()">
            <div class="row">
                <div class="col-12 form-group">
                    <h3 class="form-label">Task Name</h3>
                    <input class="form-control form-control-lg form-layout"
                           type="text"
                           formControlName="name"
                           [class.is-invalid]="isControlInvalid('name')">
                    <div class="invalid-feedback" *ngIf="controlHasError('required', 'name')">
                        This field is required!
                    </div>
                </div>

                <div class="col-12 form-group">
                    <h3 class="form-label">Description</h3>
                    <textarea class="form-control form-control-lg form-layout blue-scroll-bar"
                              formControlName="description"
                    ></textarea>
                </div>

                <div class="col-12 form-group">
                    <h3 class="form-label">Due Date</h3>
                    <input class="form-control form-control-lg form-layout"
                           type="date"
                           formControlName="dueDate"
                           [class.is-invalid]="isControlInvalid('dueDate')">
                    <div class="invalid-feedback" *ngIf="controlHasError('required', 'dueDate')">
                        This field is required!
                    </div>
                </div>

                <div *ngIf="gotStaff" class="col-12 form-group">
                    <p class="form-label">Responsible Member</p>
                    <select class="form-control form-control-lg form-layout custom-select"
                            formControlName="responsible">
                        <option *ngIf="editTaskForm.value.responsible === ''" [ngValue]="''">
                            None
                        </option>
                        <option *ngFor="let user of responsibleStaff"
                                [ngValue]="user.responsibleId">
                            {{user.responsibleName | titlecase}}
                        </option>
                    </select>

                </div>

                <div class="col-12 form-group">
                    <h3 class="form-label">New checklist item</h3>
                    <div class="d-flex justify-content-between align-items-center mb-5">
                        <input class="form-control form-control-lg form-layout"
                               type="text" #subTaskInput>
                        <button type="button" class="btn-default btn-green ml-5"
                                (click)="pushSubTask(subTaskInput.value)">
                            <span class="fas fa-plus"></span>
                        </button>
                    </div>

                    <p class="form-label">Task Checklist:</p>
                    <div *ngFor="let subTask of subTasks; let i = index"
                         class="d-flex justify-content-between align-items-center mb-5">
                        <p class="bold-text mb-0 task-description">{{ subTask.description }}</p>
                        <button type="button" class="btn-list btn-red"
                                (click)="removeSubTask(i)">
                            <span class="fas fa-trash-alt"></span>
                        </button>
                    </div>

                </div>

                <div class="col-12 d-flex justify-content-end">
                    <button type="submit" class="btn-default btn-green">
                        Save
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
